export const WEBHOOK_URL = "https://hooks.slack.com/services/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";